import { render, staticRenderFns } from "./RoutesConfig.vue?vue&type=template&id=0eae824a&"
import script from "./RoutesConfig.vue?vue&type=script&lang=js&"
export * from "./RoutesConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports